export const hasNewSidebar = () => {
	return document.querySelector('.sidebar-portal') !== null;
};
